import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { ANVIL_ANIMATION_ASSETS } from "@/components/agent-session/AnvilWorkingStatus";
import { assetUrl } from "@/lib/assetUrl";
const WELCOME_IMAGES = ["anvil-hello-dark.png", "anvil-hello-light.png", "anvil-input-dark.png", "anvil-input-light.png"];
export function useAnvilPrefetch() {
  const $ = _c(2);
  const didRun = useRef(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      if (didRun.current) {
        return;
      }
      didRun.current = true;
      for (const variant of ANVIL_ANIMATION_ASSETS) {
        for (const theme of ["dark", "light"] as const) {
          const img = new Image();
          img.src = assetUrl(`anvil-animations/anvil-${variant}-${theme}.png`);
        }
      }
      for (const name of WELCOME_IMAGES) {
        const img_0 = new Image();
        img_0.src = assetUrl(name);
      }
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
}